/* eslint-disable max-len */
import * as React from 'react'
const ServiceSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    className="icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path d="M960 403.2C921.6 185.6 736 25.6 512 25.6S102.4 192 64 403.2c-38.4 32-64 89.6-64 147.2 0 76.8 44.8 166.4 115.2 166.4 64 0 64-70.4 64-166.4 0-89.6 0-160-44.8-166.4C172.8 211.2 326.4 83.2 512 83.2c185.6 0 339.2 128 377.6 294.4-44.8 12.8-44.8 76.8-44.8 166.4 0 64 0 108.8 12.8 140.8C800 774.4 716.8 838.4 614.4 864c-19.2-25.6-57.6-44.8-102.4-44.8-64 0-115.2 32-115.2 70.4C396.8 928 448 960 512 960s115.2-32 115.2-70.4c102.4-25.6 192-96 249.6-185.6 6.4 6.4 19.2 6.4 32 6.4 70.4 0 115.2-89.6 115.2-166.4 0-51.2-25.6-108.8-64-140.8z" />
  </svg>
)
export default ServiceSvg
